export default __webpack_public_path__ + "static/media/icn_bluetooth.c032d45f.svg";